export const validateCharges = (charges, addToast) => {
  return charges.some((charge, index) => {
    const chargeNumber = index + 1

    if (!charge.chargeKind) {
      addToast(`Charge ${chargeNumber}: Category is required.`, { appearance: 'error' })
      return true
    }
    if (!charge.description.trim()) {
      addToast(`Charge ${chargeNumber}: Description cannot be empty.`, {
        appearance: 'error'
      })
      return true
    }
    if (!charge.amount) {
      addToast(`Charge ${chargeNumber}: Amount is required.`, { appearance: 'error' })
      return true
    } else if (isNaN(parseFloat(charge.amount)) || parseFloat(charge.amount) <= 0) {
      addToast(`Charge ${chargeNumber}: Amount must be a positive number.`, {
        appearance: 'error'
      })
      return true
    }
    return false
  })
}
